// client/editor/presets/plain-editor.ts
import { dropCursor } from "prosemirror-dropcursor";
import { gapCursor } from "prosemirror-gapcursor";
import { history, redo, undo } from "prosemirror-history";
import { keymap } from "prosemirror-keymap";
import { RedoMenuItem } from "../../menu-items/RedoMenuItem.js";
import { UndoMenuItem } from "../../menu-items/UndoMenuItem.js";
import { doc } from "../../nodes/doc.js";
import { paragraph } from "../../nodes/paragraph.js";
import { text } from "../../nodes/text.js";
var plainEditorConfig = () => [
  doc(),
  paragraph(),
  text(),
  {
    menuItems: [UndoMenuItem, RedoMenuItem],
    plugins: (schema) => {
      return [
        history(),
        keymap({
          "Mod-z": undo,
          "Mod-y": redo,
          "Mod-Shift-z": redo
        })
      ];
    }
  },
  {
    plugins: (schema) => {
      return [gapCursor()];
    }
  },
  {
    plugins: (schema) => {
      return [dropCursor({ color: "red", width: 2 })];
    }
  }
];
export {
  plainEditorConfig
};
